import { DateTime } from 'luxon';

export type Horizon = 'today' | 'wtd' | 'mtd' | 'ytd' | 'all';

export const HORIZONS: { key: Horizon; label: string }[] = [
  { key: 'today', label: 'Today' },
  { key: 'wtd', label: 'WTD' },
  { key: 'mtd', label: 'MTD' },
  { key: 'ytd', label: 'YTD' },
  { key: 'all', label: 'All' },
];

// The start of the horizon in the viewer's own calendar, sent as UTC, so
// "Today" is the viewer's midnight rather than the server's. Weeks start on
// Monday. "All" sends nothing.
export const horizonSince = (horizon: Horizon, now: DateTime = DateTime.local()): string | undefined => {
  switch (horizon) {
    case 'today':
      return now.startOf('day').toUTC().toISO() ?? undefined;
    case 'wtd':
      return now.startOf('week').toUTC().toISO() ?? undefined;
    case 'mtd':
      return now.startOf('month').toUTC().toISO() ?? undefined;
    case 'ytd':
      return now.startOf('year').toUTC().toISO() ?? undefined;
    default:
      return undefined;
  }
};
